import { Vue, Component } from 'vue-property-decorator'
const projectURI : string = 'https://otono-voice.com/api/v2/contents/project/'
const urlHash : string = location.search
const urlHost : string = location.hostname
const projects = require('./projects.json')

@Component({
    template: `
<div :class="'main-contents ' + projectData.backgroundImageCssClass">
  <div class="main-title">
    <div v-if="Object.keys(projectData).length === 0">
      <p class="info">アクセス可能なURLをご指定ください。</p>
    </div>
    <div v-else-if="!clientCheck">
      <p class="info">位置情報の確認をしています。しばらくお待ちください。</p>
    </div>
    <div v-else-if="!clientGeoLocation">
      <p class="info">アクセス可能な距離範囲に移動してください。</p>
    </div>
    <div v-else-if="clientGeoErrorMessage !== ''">
      <p class="info">{{ clientGeoErrorMessage }}</p>
    </div>
    <div v-else-if="clientGeoLocation">
      <p :class="'project font-heading is-5 ' + projectData.logoCssClass">{{ projectData.name }}</p>
      <p class="title font-heading is-2">{{ projectData.project }}</p>
    </div>
  </div>
  <div v-if="clientGeoLocation & showData !== undefined" class="item-list">
    <div class="player-detail">
      <p class="font-heading is-3" ><span>{{ showData.title }}</span></p>
      <p class="font-text is-1 catch">{{ showData.catch }}</p>
      <div v-if="playerUrl !== ''"><iframe class="otono-player" :src="playerUrl" width="100%" height="100" frameborder="no" allowfullscreen></iframe></div>
      <div v-else class="noPlayer">（音声がありません）</div>
      <p class="font-text is-1">{{ showData.description }}</p>
      <div class="img-outer">
        <picture v-for="img in showData.images">
          <source :srcset="img.url" media="(orientation: portrait)" />
          <img :src="img.url" :alt="img.title" />
        </picture>
      </div>
    </div>
    <a class="return" :href="'./?p=' + projectData.id + '&test=' + testMode" @click="clearHash()">一覧にもどる</a>
  </div>
  <div v-if="clientGeoLocation & showData === undefined & Object.keys(projectData).length > 0" class="section-selector">
    <div class="showdataSection" v-for="(playerData, key) in otono" :key="key">
      <p class="showdataTitle">{{key}}</p>
      <a class="shodataHash" v-for="elm in playerData" :href="'./?p=' + projectData.id + '&c=' + elm.content_hash + '&test=' + testMode" @click="setPlayerUrl(elm.content_hash)">{{ elm.title }}</a>
    </div>
  </div>
  <div class="otono">
    <p class="font-text is-1 project-title">{{ projectData.title }}</p>
    <a href="https://otono.site/" target="_blank" rel="noreferrer nofollow"><span class="by">produced by Otono</span><p class="logotext"></p></a>
  </div>
</div>
`
})

export default class results extends Vue {
    projectData : any = [];
    projectID : string = '';
    contentHash : string = '';
    testMode : string = '';

    otono : any = [];
    showData : string[] = [];
    playerUrl : string = '';

    clientCheck : boolean = false;
    clientGeoLocation : boolean = false;
    clientGeoErrorMessage : string = '';
    projectDataGeo : any = [];
    

    created() {

      if(urlHash === '') return;
      
      const urlParams = new URLSearchParams(urlHash);

      this.projectID = String(urlParams.get("p"));
      this.contentHash = String(urlParams.get("c"));

      if(!projects.hasOwnProperty(this.projectID)) return;
      
      this.projectData = projects[this.projectID];
      
      if(urlHost != this.projectData.productDomain) {
        this.testMode = String(urlParams.get("test"));
      }

      this.projectDataGeo = Object.values(this.projectData.geometries).flat();

      if(navigator.geolocation) {
        navigator.geolocation.watchPosition(this.checkGeo, this.errorGeo);
      } else {
        this.clientCheck = true;
      }
    }


    getData() {
      
      if(!this.clientGeoLocation) return;

      const fetchPromise = fetch(projectURI + this.projectID + '.json');

      fetchPromise.then(response => {
        return response.json();
      }).then(data => {
        this.otono = data;
        if(this.contentHash !== '') {
          this.setPlayerUrl(this.contentHash);
        }
      });

    }

    setPlayerUrl(hash : any) {
        if (hash !== '') {
            this.playerUrl = 'https://otono-voice.com/audio/' + hash + '?locale=ja';
        }

        let allData = Object.values(this.otono).flat();
        let data = Array.prototype.filter.call(Object(allData), (elm) => {
          return elm.content_hash === hash;
        });
        this.showData = data.shift();
    }

    clearHash() {
      this.contentHash = '';
      this.playerUrl = '';
      this.showData = [];
    }

    checkGeo(position : any) {
      const R = Math.PI / 180;

      let lat1, lng1, lat2, lng2, distance2;
      let distance;

      lat1 = position.coords.latitude * R;
      lng1 = position.coords.longitude * R;

      lat2 = this.projectDataGeo[0] * R;
      lng2 = this.projectDataGeo[1] * R;
      distance2 = parseInt(this.projectDataGeo[2])/1000;

      distance = 6371 * Math.acos(Math.cos(lat1) * Math.cos(lat2) * Math.cos(lng2 - lng1) + Math.sin(lat1) * Math.sin(lat2));

      if (distance <=  distance2) {
        if(!this.clientGeoLocation) {
          this.clientGeoLocation = true;
          this.getData();
        }
      } else {
        this.clientGeoLocation = false;
      }

      if (this.testMode === '1') {
        if(!this.clientGeoLocation) {
          this.clientGeoLocation = true;
          this.getData();
        }
      }

      this.clientCheck = true;
    }

    errorGeo(error : any) {
      // エラーコードのメッセージを定義
      let errorMessage : any = {
        0: "原因不明のエラーが発生しました…。" ,
        1: "位置情報の取得が許可されませんでした…。" ,
        2: "電波状況などで位置情報が取得できませんでした…。" ,
        3: "位置情報の取得に時間がかかり過ぎてタイムアウトしました…。" ,
      } ;

      this.clientGeoErrorMessage = errorMessage[error.code];
    }
}